/**
 * Web observability init — creates platform backends and wires them
 * into the shared observability layer.
 */

import { setBackends } from "@orb-labs/orby-react";
import type { AnalyticsBackend, ErrorMonitoringBackend } from "@orb-labs/orby-react";
import { createWebPosthogBackend } from "@/observability/webPosthogBackend";
import { createWebSentryBackend } from "@/observability/webSentryBackend";

export {
  persistReferralCode,
  persistCampaignAttribution,
  getStoredAttribution,
  captureCTAClick,
} from "@/observability/webPosthogBackend";

let _analytics: AnalyticsBackend | undefined;
let _errorMonitoring: ErrorMonitoringBackend | undefined;

export function initObservability(): void {
  _analytics = createWebPosthogBackend();
  _errorMonitoring = createWebSentryBackend();
  setBackends(_analytics, _errorMonitoring);
}

export function getWebAnalyticsBackend(): AnalyticsBackend {
  if (!_analytics) throw new Error("initObservability() must be called first");
  return _analytics;
}

export function getWebErrorBackend(): ErrorMonitoringBackend {
  if (!_errorMonitoring) throw new Error("initObservability() must be called first");
  return _errorMonitoring;
}
